/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content-with-filled-button[_ngcontent-%COMP%]{min-height:calc(100vh - 265px);margin-top:32px}.title[_ngcontent-%COMP%]{font-size:32px;color:#231d19;line-height:40px;font-weight:900;margin-bottom:30px;margin-top:20px}.sub-title[_ngcontent-%COMP%]{font-size:24px;color:#231d19;line-height:32px;font-weight:300;margin-bottom:30px;margin-top:20px}.magin_top_20[_ngcontent-%COMP%]{margin-top:20px}.magin_top_10[_ngcontent-%COMP%]{margin-top:10px}@media (min-width:768px){.title[_ngcontent-%COMP%]{font-size:40px;line-height:48px}}"];
export { styles as styles };
